<template>
  <div class="header">
    <div class="header_logo"
         @click="menuRedirect({path: '/m'})">
      <img @click.prevent
           :src="LOGO_ICON"
           alt="">
    </div>
    <div class="header_btn"
         @click="menuToggle">
      <img @click.prevent
           :src="MENU_ICON"
           alt="">
    </div>
    <transition name="slide-fade">
      <div class="popup"
           v-show="menuShow">
        <div class="mask"
             @touchmove.prevent
             @click="maskClick">
        </div>
        <div class="header_menu">
          <ul class="header_menu_ul">
            <li class="lang">
              <span :class="str === 'cn' ? 'active' : ''"
                    @click="changeLanguage('cn')">简</span>/
              <span :class="str === 'zh' ? 'active' : ''"
                    @click="changeLanguage('zh')">繁</span>
              <!-- /<span :class="str === 'en' ? 'active' : ''"
                    @click="changeLanguage('en')">En</span> -->
            </li>
            <li class="header_menu_ul_li"
                v-for="(menu, index) in showData.MENUS"
                :key="index"
                @click="menuRedirect(menu)">
              {{ menu.name }}
            </li>
          </ul>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import language from 'mixins/language' // 预留 多语言混入实例

export default {
  name: '',
  mixins: [language],
  props: [''],
  data () {
    return {
      str: localStorage.getItem('UTOPA_LANGUAGE') || 'cn',
      MENU_ICON: require('images/header/menu_icon.png'),
      LOGO_ICON: require('images/header/logo.png'),
      menuShow: false,
      CN: {
        MENUS: [
          { name: '优托邦项目介绍', path: '/m/project' },
          { name: '运营服务', path: '/m/service' },
          { name: '主力品牌', path: '/m/brand' },
          { name: '发展规划', path: '/m/progress' },
          { name: '合作伙伴', path: '/m/partner' },
          { name: '人才招聘', path: '/m/join' },
          { name: '平台规则', path: '' }
        ]
      },
      EN: {

      },
      ZH: {
        MENUS: [
          { name: '優托邦項目介紹', path: '/m/project' },
          { name: '運營服務', path: '/m/service' },
          { name: '主力品牌', path: '/m/brand' },
          { name: '發展規劃', path: '/m/progress' },
          { name: '合作夥伴', path: '/m/partner' },
          { name: '人才招聘', path: '/m/join' },
          { name: '平台規則', path: '' }
        ]
      }
    }
  },
  components: {},
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {
    changeLanguage (str) {
      this.str = str
      this.$store.dispatch('CHANGE_LANGUAGE', str)
      this.maskClick()
    },
    menuToggle () {
      this.menuShow = !this.menuShow
    },
    menuRedirect (menu) {
      if (!menu.path) {
        window.open('https://www.myutopa.com/m/mall/#/pages/help-center/common-problem/index?theme=%23ff445e&appType=2&proTypeId=14')
        return
      }
      this.maskClick()
      this.$router.push({
        path: menu.path
      })
    },
    maskClick () {
      this.menuShow = false
    }
  }
}

</script>
<style lang='scss' scoped>
@import "px2rem";
.header {
  height: px2rem(44);
  background: #ffffff;
  box-shadow: 0 px2rem(2) px2rem(8) 0 rgba(0, 0, 0, 0.1);
  position: fixed;
  z-index: 1;
  width: 100%;
  top: 0;
  left: 0;
  &_logo {
    position: absolute;
    width: px2rem(76);
    height: px2rem(28);
    left: px2rem(15);
    top: px2rem(9);
    img {
      width: 100%;
    }
  }
  &_btn {
    position: absolute;
    width: px2rem(34);
    height: px2rem(32);
    padding: px2rem(10);
    right: px2rem(10);
    top: px2rem(6);
    img {
      width: 100%;
    }
  }
  &_menu {
    position: absolute;
    width: 100%;
    height: 100%;
    &_ul {
      pointer-events: auto;
      position: absolute;
      width: px2rem(170);
      // height: px2rem(312);
      background: #ffffff;
      top: px2rem(44);
      right: 0;
      border: px2rem(1) solid #e0e0e0;
      text-align: center;
      padding-top: px2rem(10);
      &_li {
        color: #858896;
        font-size: px2rem(16);
        line-height: px2rem(22);
        margin-bottom: px2rem(20);
      }
      .lang {
        min-height: px2rem(46);
        text-align: right;
        font-size: px2rem(17);
        color: #999990;
        padding: 0 px2rem(10) px2rem(15) 0;
        .active {
          font-size: px2rem(24);
          color: #00afac;
        }
      }
    }
  }
  .popup {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    pointer-events: none;
    .mask {
      position: absolute;
      width: 100%;
      height: 100%;
      pointer-events: auto;
      // background-color: rgba(0, 0, 0, 0.1);
    }
  }
}
.slide-fade-enter-active {
  transition: all 0.1s ease-in;
}
.slide-fade-leave-active {
  transition: all 0.1s ease;
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateX(px2rem(20));
  opacity: 0;
}
</style>
